import React from "react";
import RentBanner from "./RentBanner";
import RentSubNavi from "./RentSubNavi";
import RentCart from "./RentCart";
import AnyQuestion from "./AnyQuestion";
import StayTouch from "../../layout/StayTouch";
import layoutWrapper from "../../components/Hoc/layoutWrapper";
class Rent extends React.Component {
  render() {
    return (
      <div>
        <RentBanner />
        {/*<RentSubNavi />*/}
        <RentCart />
        <AnyQuestion />
        <StayTouch />
      </div>
    );
  }
}

export default layoutWrapper(Rent);



// WEBPACK FOOTER //
// ./src/pages/rent/index.js